<template>
  <div>
    <b-card
      :header="
        currentView == ''
          ? uLang('app.loading') + '...'
          : uLang('app.' + currentView)
      "
      header-tag="h4"
      class="bg-default-card"
    >
      <component
        v-if="currentView != ''"
        v-bind:is="loadComponent"
        :settingId="id"
      >
        <!--Loads specific setting component   -->
      </component>
    </b-card>
  </div>
</template>

<script>
import {
    ApplicationStatus,
    ApplicationActivityType,
    BlikOpWerk,
    CostCenter,
    Countries,
    DocumentTypes,
    LocationTypes,
    LogCategories,
    Regions,
    Roles,
    Types,
    Welfares,
    ReportingLogTypes,
    ReportingLogActivityTypes,
    WebsiteBranches,
    WebsiteTargetAudiences,
    WebsiteServices,
    WebsiteTrajectories,
    Brontypes
} from "~/components/forms/setting";
import {TrajectoryTypes} from "../../../components/forms/setting";

export default {
  name: "edit",
  props: {
    id: {
      required: true,
    },
  },

  data() {
    return {
      currentView: "",
    };
  },

  components: {
      application_status: ApplicationStatus,
      application_activity_type: ApplicationActivityType,
      blik_op_werk: BlikOpWerk,
      cost_center: CostCenter,
      countries: Countries,
      document_types: DocumentTypes,
      location_types: LocationTypes,
      log_categories: LogCategories,
      regions: Regions,
      roles: Roles,
      types: Types,
      welfares: Welfares,
      reporting_log_types: ReportingLogTypes,
      reporting_log_activity_types: ReportingLogActivityTypes,
      trajectory_types: TrajectoryTypes,
      website_target_audiences: WebsiteTargetAudiences,
      website_branches: WebsiteBranches,
      website_services: WebsiteServices,
      website_trajectories: WebsiteTrajectories,
      bron_types: Brontypes,
  },

  computed: {
    loadComponent() {
      return this.currentView;
    },
  },

  created: function() {
    this.retrieveSetting();
  },

  methods: {
    async retrieveSetting() {
      const { data } = await window.axios.get("/api/admin/settings/" + this.id);
      this.currentView = data.name;
    },
  },
};
</script>

<style lang="css" scoped></style>
